
export default function () {
  return {

    canSelect: {
      ru: 'Можно выбрать',
      ua: 'Можна вибрати'
    },

    can: {
      ru: 'Можно',
      ua: 'Можна'
    },
    canT: {
      ru: 'Нельзя',
      ua: 'Не можна'
    },
    changeAnswer: {
      ru: 'менять ответы.',
      ua: 'міняти відповіді.'
    },
    countAnswer: {
      ru: 'Всего голосов:',
      ua: 'Всього голосів:'
    },
    answer1: {
      ru: 'вариант ответа',
      ua: 'варіант відповіді'
    },
    answer2: {
      ru: 'варианта ответа',
      ua: 'варіанта відповіді'
    },
    answer3: {
      ru: 'вариантов ответа',
      ua: 'варіантів відповіді'
    },
    vote: {
      ru: 'Голосовать',
      ua: 'Голосувати'
    },
    votingClosed: {
      ru: 'Голосование закрыто',
      ua: 'Голосування закрито'
    }
  };
}
